import { Box } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import * as styles from './styles.css';

interface Props
  extends Omit<ComponentProps<typeof Box>, 'className' | 'margin'> {
  className?: string;
}

export const CentredBox = ({ children, className, ...props }: Props) => (
  <Box
    {...props}
    className={[styles.centred, ...(className ? [className] : [])]}
    margin={['none', 'gutter']}
    padding="xlarge"
  >
    {children}
  </Box>
);
